export enum AuthType {
  TIME_AND_MATERIAL = 'Time and Material',
  UNIT_PRICE = 'Unit Price',
}
